import {RemoteConfigProps} from "./firebase.types";

export const REMOTE_CONFIG_DEFAULTS: RemoteConfigProps = {
  A_LA_CARTE_PRICING: `{
  "perAIRespondentPrice": 15,
  "perHumanRespondentPrice": 30,
  "perRespondentPrice": 16,
  "perCriteriaPrice": 25,
  "perAICriteriaPrice": 0,
  "perHumanCriteriaPrice": 25
}`,
  ALLOW_FREEFORM: false,
  CREATE_ACCOUNT_COPY: `{
    "title": "Create account on Invisibly Research"
  }`,
  CREATE_SURVEY_COPY: `{
    "betaHeader": "",
    "humanSampleTooltip": "Invisibly’s human sample comes from real, opt-in Invisibly app users. This ensures genuine and diverse feedback from engaged participants.",
    "aiSampleTooltip": "Invisibly’s AI Panelist audience is made up of AI-powered personas that mirror real human behavior and demographics. Go to invisibly.com/business to learn how it works",
    "targetingTooltip": "Target your survey to specific audiences based on demographics, interests, or behaviors for more precise insights. Keep in mind that the more targeted your audience, the longer it may take for our real human users to respond.",
    "rationaleToggle": "Provide rationale"
  }`,
  DASHBOARD_EMPTY_STATE_COPY: `{
    "emptyStateTitle": "Get answers fast with Invisibly",
    "emptyStateSubtitle": "Create your first survey and discover what your audience is thinking.",
    "learnMoreHelperText": "about Invisibly Research.",
    "learnMoreLink": "https://www.invisibly.com/business/"
  }`,
  MAX_CRITERIA: 3,
  MAX_QUESTION_COUNT: 25,
  RESULTS_AUTO_REFRESH_SECONDS: 15,
  SAMPLE_SIZES: `{
    "human": [0,30,50,100,250],
    "ai": [0,100,200,500,750,1000]
  }`,
  SIGN_IN_COPY: `{
    "title": "Sign into Invisibly Research"
  }`,
  SURVEY_CONFIDENCE_INTERVALS: `[
    {
      "percentage": 85,
      "human_sample_size": 50,
      "ai_sample_size": 100
    },
    {
      "percentage": 90,
      "human_sample_size": 100,
      "ai_sample_size": 200
    }
  ]`,
  SURVEYS_DEFAULT_CONFIDENCE: true,
  SURVEYS_DEFAULT_TARGETED: false,
  USE_DASHBOARD_REDESIGN: false,
  USE_RESULTS_REDESIGN: true,
};
